import likes from '../img/statistics/like.png';
import order from '../img/statistics/order.png';
import happy from '../img/statistics/happy.png';
import product from '../img/statistics/product.png';

const Statistics = () => {
  return (
    <section id="stat" className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="text-center mb-20">
          <h1
            className="
              text-5xl
              font-medium
              title-font
              mb-4
            "
          >
            Our Statistics
          </h1>
          <div className="flex mt-6 justify-center">
            <div
              className="
                w-28
                h-2
                rounded-full
                bg-purple-500
                inline-flex
              "
            ></div>
          </div>
        </div>
        <div className="flex flex-wrap -m-4 text-center">
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div
              className="
                border-2 border-gray-200
                px-4
                py-6
                rounded-lg
              "
            >
              <img className="w-14 mx-auto" src={likes} alt="likes" />
              <h2
                className="
                  mt-5
                  title-font
                  font-medium
                  text-3xl text-gray-600
                "
              >
                333
              </h2>
              <p className="leading-relaxed">Page Likes</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div
              className="
                border-2 border-gray-200
                px-4
                py-6
                rounded-lg
              "
            >
              <img className="w-14 mx-auto" src={order} alt="order" />
              <h2
                className="
                  mt-5
                  title-font
                  font-medium
                  text-3xl text-gray-600
                "
              >
                100
              </h2>
              <p className="leading-relaxed">Order Completed</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div
              className="
                border-2 border-gray-200
                px-4
                py-6
                rounded-lg
              "
            >
              <img className="w-14 mx-auto" src={happy} alt="happy" />
              <h2
                className="
                  mt-5
                  title-font
                  font-medium
                  text-3xl text-gray-600
                "
              >
                97
              </h2>
              <p className="leading-relaxed">Happy Customers</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div
              className="
                border-2 border-gray-200
                px-4
                py-6
                rounded-lg
              "
            >
              <img className="w-14 mx-auto" src={product} alt="product" />
              <h2
                className="
                  mt-5
                  title-font
                  font-medium
                  text-3xl text-gray-600
                "
              >
                8
              </h2>
              <p className="leading-relaxed">Items</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;
